/**
 * Returns the appropriate domain based on the environment.
 * - In production: '.parkinglap.com'
 * - In development: 'localhost'
 */
const getCookieDomain = (): string | undefined => {
  return process.env.REACT_APP_ENV === 'production' ? '.parkinglap.com' : 'localhost';
};

/**
 * Sets a cookie with the specified name, value, and expiration days.
 * The domain is determined automatically based on the environment.
 */
export const setCookie = (name: string, value: string, days: number = 7) => {
  const domain = getCookieDomain();
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax${domainPart}`;
};

/**
 * Retrieves the value of a cookie by its name.
 */
export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

/**
 * Deletes a cookie by its name.
 * The domain is determined automatically based on the environment.
 */
export const deleteCookie = (name: string) => {
  const domain = getCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax${domainPart}`;
};